import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Transition } from 'react-transition-group';

import LiberacaoAcesso from '../../components/LiberacaoAcesso';

import Lottie from 'react-lottie'
import animationSuccess from '~/assets/animations/success.json';
import animationError from '~/assets/animations/error.json';
import animationWarning from '~/assets/animations/warning.json';
import animationQuestion from '~/assets/animations/question.json';
import animationInfo from '~/assets/animations/info.json';

const animations = {
  success: animationSuccess,
  error: animationError,
  warning: animationWarning,
  question: animationQuestion,
  info: animationInfo
}

const DisplayIcon = ({ icon }) => {
  if (!icon) return null
  if (icon === 'danger') icon = 'error'
  const lottieIcon = animations[icon]
  if (!lottieIcon) return null
  return (
    <Lottie
      key={icon}
      options={{
        loop: false,
        autoplay: true,
        animationData: lottieIcon,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        }
      }}
      height={100}
      width={100}
      isStopped={false}
      isPaused={false}
      style={{
        transform: 'scale(2.45)',
        transformOrigin: 'center',
        pointerEvents: 'none',
        margin: '1.25em auto 1.25em'
      }}
    />
  )
}

const bounceKeyframes = `
@keyframes swal-bounce {
  0%   { transform: scale(0.7); opacity: 0; }
  45%  { transform: scale(1.05); opacity: 1; }
  65%  { transform: scale(0.95); }
  80%  { transform: scale(1.02); }
  100% { transform: scale(1); }
}
`;

const duration = 400;

const BounceTransition = React.forwardRef(function BounceTransition(props, ref) {
  const { in: inProp, children, ...other } = props;

  return (
    <Transition in={inProp} timeout={duration} {...other}>
      {state =>
        React.cloneElement(children, {
          ref,
          style: {
            ...children.props.style,
            animation:
              state === 'entering' || state === 'entered'
                ? `swal-bounce ${duration}ms ease-out`
                : 'none'
          }
        })
      }
    </Transition>
  );
});

const ModalConfirmacao = ({ title, body, options, rotina, open, onClose, onCloseCallback }) => {
  const [disableModal, setDisableModal] = useState(true);
  const [tokenLiberacaoRotina, setTokenLiberacaoRotina] = useState(null);

  useEffect(() => {
    if (!document.getElementById('swal-bounce-style')) {
      const style = document.createElement('style');
      style.id = 'swal-bounce-style';
      style.innerHTML = bounceKeyframes;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <Dialog
      open={open}
      onKeyDown={key => {
        if (key.code === 'Escape') {
          onClose();
        }
      }}
      PaperComponent={Paper}
      onClose={onClose}
      TransitionComponent={BounceTransition}
      maxWidth={'md'}
    >
      <DialogContent style={{ width: "32em", maxWidth: "100%", display: 'flex', flexDirection: 'column', gap: '8px', padding: "1.25em", paddingBottom: 0, borderRadius: "5px", fontSize: "1rem" }}>
        <Box className="swal2-header" textAlign="center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <DisplayIcon key={open} icon={options.icon}/>
          <h2 className="swal2-title">{title}</h2>
        </Box>
        <Box className='swal2-content' textAlign="center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '8px'}}>
          <div className='swal2-html-container'>{body}</div>
        </Box>

        {disableModal && (
          <LiberacaoAcesso
            orientation="vertical"
            rotina={rotina}
            callback={(acesso, token) => {
              setDisableModal(!acesso);
              if (acesso) {
                setTokenLiberacaoRotina(token);
              }
            }}
          />
        )}
      </DialogContent>

      <DialogActions style={{ width: "32em", maxWidth: "100%", display: 'flex', flexDirection: 'column', gap: '8px', padding: "1.25em", paddingTop: 0, borderRadius: "5px", fontSize: "1rem", alignItems: 'stretch' }}>
        <Box className="swal2-actions" textAlign="center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginTop: '1.8em' }}>
          <Button
            variant="contained"
            className={`button-${options.icon}`}
            disabled={disableModal}
            onClick={() => onCloseCallback(tokenLiberacaoRotina)}
          >
            <span style={{ verticalAlign: 'middle' }}>{options?.confirmButtonText}</span>
          </Button>

          <Button
            variant="contained"
            className={`button-white`}
            onClick={onClose}
          >
            {options?.cancelButtonText ?? 'Cancelar'}
          </Button>
        </Box>
      </DialogActions>

    </Dialog>
  );
};

export default ModalConfirmacao;
